import * as React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

export const TimeLogo = ({ fill = '#44338A' }: { fill?: string }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={12} height={16} fill="none">
                <path
                    stroke="#44338A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 8 3.151 5.626c-.423-.353-.634-.529-.787-.745a2 2 0 0 1-.295-.631C2 3.994 2 3.719 2 3.168V1.333M6 8l2.849-2.374c.423-.353.634-.529.787-.745a2 2 0 0 0 .295-.631C10 3.994 10 3.719 10 3.168V1.333M6 8l-2.849 2.374c-.423.352-.634.529-.787.745a2 2 0 0 0-.295.632C2 12.006 2 12.28 2 12.832v1.835M6 8l2.849 2.374c.423.352.634.529.787.745a2 2 0 0 1 .295.632c.069.255.069.53.069 1.081v1.835M.667 1.333h10.666M.667 14.667h10.666"
                />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={26} height={30} fill="none">
                <path
                    stroke="#44338A"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={3}
                    d="m13 15-5.697-4.748c-.847-.705-1.27-1.058-1.574-1.49a4 4 0 0 1-.592-1.263C5 6.989 5 6.438 5 5.336v-3.67M13 15l5.697-4.748c.847-.705 1.27-1.058 1.574-1.49a4 4 0 0 0 .592-1.263C21 6.989 21 6.438 21 5.336v-3.67M13 15l-5.697 4.748c-.847.705-1.27 1.058-1.574 1.49a4 4 0 0 0-.592 1.263C5 23.01 5 23.562 5 24.664v3.67M13 15l5.697 4.748c.847.705 1.27 1.058 1.574 1.49a4 4 0 0 1 .592 1.263c.137.51.137 1.061.137 2.163v3.67M2.333 1.666h21.334M2.333 28.333h21.334"
                />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width={12} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6 8 3.151 5.626c-.423-.353-.634-.529-.787-.745a2 2 0 0 1-.295-.631C2 3.994 2 3.719 2 3.168V1.333M6 8l2.849-2.374c.423-.353.634-.529.787-.745a2 2 0 0 0 .295-.631C10 3.994 10 3.719 10 3.168V1.333M6 8l-2.849 2.374c-.423.352-.634.529-.787.745a2 2 0 0 0-.295.632C2 12.006 2 12.28 2 12.832v1.835M6 8l2.849 2.374c.423.352.634.529.787.745a2 2 0 0 1 .295.632c.069.255.069.53.069 1.081v1.835M.667 1.333h10.666M.667 14.667h10.666"
                stroke={fill}
                strokeWidth={1}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
